import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  fetchMarcarLeidasNotificaciones,
  fetchTotalNotificaciones
} from '../../../actions/notificacionesActions';
import { formatoFecha } from '../../../utilities/formatoFecha'
import { toast } from '../../../utilities/appToast';
import '../Styles/Notificaciones.css'

class NotificacionList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      notificaciones: this.props.notificaciones === [] ? [] : this.props.notificaciones,
      seleccionarTodo: false
    }
  };

  handleChangeCheckbox = (id) => {
    this.setState((prevState) => {
      const notificaciones = prevState.notificaciones.map((notificacion) => {
        if (notificacion.idMensaje === id) {
          return {
            ...notificacion,
            checked: !notificacion.checked
          };
        }
        return notificacion;
      });
      return { notificaciones };
    });
  };

  handleSelectAllCheckbox(seleccionarTodo) {
    this.setState((prevState) => {
      const notificaciones = prevState.notificaciones.map((notificacion) => ({
        ...notificacion,
        checked: seleccionarTodo
      }));
      return { notificaciones };
    });
    this.setState({ seleccionarTodo: seleccionarTodo });
  };

  async marcarLeidas(listaIds) {
    if (listaIds.length > 0) {
      await this.props.fetchMarcarLeidasNotificaciones({ idSeller: this.props.idSeller, idMensaje: listaIds })
      setTimeout(() => {
        this.props.fetchDetalleFunction();
        // this.props.fetchTotalNotificaciones({
        //   idSeller: this.props.idSeller, 
        //   tipoUsuario: this.props.tipoUsuario
        // });
      }, 300);
    } else {
      toast.warn('Debe seleccionar una notificación')
    }
  }


  render = () => {

    const { onNotificacionFunction, tipoNotificacion } = this.props;
    const mostrarDiferencia = tipoNotificacion === 0 || tipoNotificacion === 1;

    return (
      <div className="tab-content">
        <div className="container-fuid over-tab">
          <div className="row justify-content-between align-items-center">

            <div className="col-auto my-2">
              <input
                type="checkbox"
                name="seleccionarTodas"
                className="mx-3 big-checkbox"
                checked={this.state.seleccionarTodo}
                onChange={() => this.handleSelectAllCheckbox(!this.state.seleccionarTodo)}
              />
              <h6 className="d-inline-flex"> Seleccionar todo</h6>
            </div>

            <div className="col-auto my-2 mb-sm-0 mb-4">
              <button
                name="marcarTodasLeidas"
                className="btn btn-sm background-rojo-megatone waves-effect waves-light mx-3"
                onClick={
                  () => this.marcarLeidas(this.state.notificaciones.filter(x => x.checked === true).map(x => x.idMensaje))
                }
              >
                Marcar como leído
              </button>
            </div>

          </div>
        </div>

        {
          this.state.notificaciones.map((notificacion, index) => {
            return (
              <div
                key={index}
                className="list-group-item hover-background-color col-12 animated fadeIn p-2"
                onClick={
                  (e) => (e.target.name !== "checkNotificacion") ?
                    onNotificacionFunction(notificacion.id) : false
                }
              >
                <div className="container-fuid">
                  <div className="row align-items-center">

                    <div className="col-5 col-sm-2">
                      <div className="w-100 row text-break align-items-center">

                        <div className="col-3 text-end">
                          <input
                            type="checkbox"
                            name="checkNotificacion"
                            className="big-checkbox"
                            checked={notificacion.checked || false}
                            onChange={() => this.handleChangeCheckbox(notificacion.idMensaje)}
                          />
                        </div>

                        <div className="col-9">
                          <div className="displayInlineTable">
                            <span className="font-size-072rem">SKU MARKET</span>
                            <h6 className="font-weight-bold box-title mb-0">
                              {notificacion.codigoProducto}
                            </h6>
                          </div>
                        </div>

                      </div>
                    </div>

                    <div className="col-3 col-sm-1 text-center">
                      <img
                        className="mw-60px img-responsive"
                        src={notificacion.imagen}
                        alt={notificacion.titulo.substring(0, 10) + "..."}
                      />
                    </div>

                    <div className={mostrarDiferencia ? 'col-4' : 'col-7'}>
                      <small className="font-size-072rem">Titulo</small>
                      <h6 className="font-weight-bold box-title m-b-0">{notificacion.titulo}</h6>
                    </div>

                    <div className="col-8 col-sm-3" hidden={!mostrarDiferencia}>
                      <div className="w-100 row text-break">
                        <div className="col-6">
                          <small className="font-size-072rem">Anterior</small>
                          <h6 className="font-weight-bold box-title m-b-0">
                            {notificacion.cambio === "" || notificacion.cambio === null ? "-" : notificacion.cambio}
                          </h6>
                        </div>
                        <div className="col-6">
                          <small className="font-size-072rem">Actual</small>
                          <h6 className="font-weight-bold box-title m-b-0">
                            {notificacion.actual === "" || notificacion.actual === null ? "-" : notificacion.actual}
                          </h6>
                        </div>
                      </div>
                    </div>

                    <div className="col-3 col-sm-2">
                      <small className="font-size-072rem">Fecha</small>
                      <h6 className="font-weight-bold box-title m-b-0">
                        {
                          notificacion.fecha === "" || notificacion.fecha === null ?
                            "-" : formatoFecha(notificacion.fecha)
                        }
                      </h6>
                    </div>

                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  idSeller: state.general.idSeller,
  tipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, {
  fetchMarcarLeidasNotificaciones,
  fetchTotalNotificaciones
})(NotificacionList);